import { createContext, type ReactNode, useContext } from "react";

const PageUtilitiesContext = createContext<ReactNode>(null);

export function PageUtilitiesProvider({
  children,
  utilities,
}: {
  children: ReactNode;
  utilities?: ReactNode;
}) {
  return (
    <PageUtilitiesContext.Provider value={utilities ?? null}>
      {children}
    </PageUtilitiesContext.Provider>
  );
}

export function usePageUtilities(): ReactNode {
  return useContext(PageUtilitiesContext);
}
